<template>
    <div v-show="IsShow">
        <div class="loading">
            <i class="icon iconfont icon-loading2">
            </i>
        </div>
        <div class="loading-mask"></div>
    </div>
</template>

<style lang="less" scoped>
.loading-mask {
  position: fixed;
  height: 100%;
  width: 100%;
  top: 0;
  background: rgba(0, 0, 0, 0);
  z-index: 999;
}
.loading {
  position: absolute;
  width: 0.5rem;
  height: 0.5rem;
  left: 44%;
  top: 40%;
  background: rgba(0, 0, 0, 0.1);
  border-radius: 0.1rem;
  z-index: 1000;
}
.iconfont{
    font-size: 0.3rem;
    position: absolute;
    top: 0.1rem;
    left: 0.1rem;
    animation: rotate 1.5s steps(13) infinite;
}
@keyframes rotate {
    from{
        transform: rotate(0deg)
    }
    to{
        transform: rotate(360deg)
    }
    
}
</style>

<script>
export default {
  props: {
    IsShow: false
  }
};
</script>



// WEBPACK FOOTER //
// src/components/loading/loading.vue